import React from 'react';
import { Link } from 'react-router-dom';

const PrivacyPolicy = () => {
  return (
    <div className="min-h-screen bg-black text-white">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 py-12">
        <Link to="/" className="text-orange-500 hover:text-orange-600 mb-8 inline-block">
          ← Back to Home
        </Link>
        
        <h1 className="text-4xl font-bold mb-4">Privacy Policy</h1>
        <p className="text-gray-400 mb-8">Last Updated: {new Date().toLocaleDateString()}</p>
        
        <div className="space-y-8 text-gray-300">
          <section>
            <h2 className="text-2xl font-bold text-white mb-4">1. Information We Collect</h2>
            
            <h3 className="text-xl font-semibold text-orange-500 mt-4 mb-2">Account Information</h3>
            <ul className="list-disc list-inside space-y-2">
              <li>Email address</li>
              <li>Username/handle</li>
              <li>Password (encrypted)</li>
              <li>Profile information (bio, avatar, links)</li>
            </ul>

            <h3 className="text-xl font-semibold text-orange-500 mt-4 mb-2">Usage Data</h3>
            <ul className="list-disc list-inside space-y-2">
              <li>Pages viewed and content accessed</li>
              <li>Search queries</li>
              <li>Interaction data (likes, comments, follows)</li>
              <li>Device information and IP address</li>
              <li>Browser type and operating system</li>
            </ul>

            <h3 className="text-xl font-semibold text-orange-500 mt-4 mb-2">Payment Information</h3>
            <p>
              Payment information is processed by Stripe. We do not store credit card numbers on our servers.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-white mb-4">2. How We Use Your Information</h2>
            <ul className="list-disc list-inside space-y-2">
              <li>To provide and improve the Platform</li>
              <li>To personalize your experience and recommendations</li>
              <li>To process payments and subscriptions</li>
              <li>To send notifications about activity on your content</li>
              <li>To enforce our Terms of Service</li>
              <li>To comply with legal obligations</li>
              <li>To detect and prevent fraud or abuse</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-white mb-4">3. Information Sharing</h2>
            <p className="mb-3">We do NOT sell your personal information. We may share data with:</p>
            <ul className="list-disc list-inside space-y-2">
              <li><strong>Service Providers:</strong> Stripe (payments), SendGrid (emails), hosting providers</li>
              <li><strong>Other Users:</strong> Your public profile, content, and activity are visible to other users</li>
              <li><strong>Legal Requirements:</strong> When required by law or to protect rights and safety</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-white mb-4">4. Cookies & Tracking</h2>
            <p className="mb-3">
              We use cookies and similar technologies to:
            </p>
            <ul className="list-disc list-inside space-y-2">
              <li>Keep you logged in</li>
              <li>Remember your preferences</li>
              <li>Analyze platform usage</li>
              <li>Provide relevant recommendations</li>
            </ul>
            <p className="mt-3">
              You can control cookies through your browser settings, but some features may not work properly if disabled.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-white mb-4">5. Data Security</h2>
            <p>
              We implement security measures to protect your data, including:
            </p>
            <ul className="list-disc list-inside space-y-2 mt-2">
              <li>Encrypted passwords (bcrypt)</li>
              <li>HTTPS encryption for data transmission</li>
              <li>Regular security audits</li>
              <li>Access controls and authentication</li>
            </ul>
            <p className="mt-3 text-yellow-500">
              However, no system is 100% secure. Use strong passwords and enable two-factor authentication when available.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-white mb-4">6. Your Rights (GDPR & CCPA)</h2>
            <p className="mb-3">You have the right to:</p>
            <ul className="list-disc list-inside space-y-2">
              <li><strong>Access:</strong> Request a copy of your personal data</li>
              <li><strong>Correction:</strong> Update inaccurate information</li>
              <li><strong>Deletion:</strong> Request deletion of your account and data</li>
              <li><strong>Portability:</strong> Export your data in a common format</li>
              <li><strong>Opt-Out:</strong> Unsubscribe from marketing emails</li>
            </ul>
            <p className="mt-3">
              To exercise these rights, contact <a href="mailto:privacy@trapcomix.com" className="text-orange-500 hover:text-orange-600">privacy@trapcomix.com</a>
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-white mb-4">7. Children's Privacy</h2>
            <p>
              Trap Comix is not intended for children under 13. We do not knowingly collect data from children. 
              If you believe a child has provided information, please contact us immediately.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-white mb-4">8. International Users</h2>
            <p>
              Trap Comix is based in the United States. By using the Platform, you consent to the transfer of your data to the US, 
              which may have different data protection laws than your country.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-white mb-4">9. Changes to This Policy</h2>
            <p>
              We may update this Privacy Policy periodically. We will notify you of significant changes via email or platform notification.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-white mb-4">10. Contact Us</h2>
            <p>
              For privacy questions or requests, contact: <br />
              <a href="mailto:privacy@trapcomix.com" className="text-orange-500 hover:text-orange-600">
                privacy@trapcomix.com
              </a>
            </p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;